import { Directive, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[resBusySpinner]'
})
export class BusySpinnerDirective {
    @Input()
    set resBusySpinner(isBusy: boolean) {
        if (typeof isBusy === 'boolean') {
            if (!this.backdropElement || !this.spinnerElement) {
                this.buildSpinner();
            }
            if (isBusy) {
                this.renderer.setStyle(this.backdropElement, 'display', 'inherit');
                this.renderer.setStyle(this.spinnerElement, 'display', 'inherit');
            } else {
                this.renderer.setStyle(this.backdropElement, 'display', 'none');
                this.renderer.setStyle(this.spinnerElement, 'display', 'none');
            }
        }
    }
    @Input()
    set message(text: string) {
        if (typeof text === 'string') {
            if (!this.backdropElement || !this.spinnerElement) {
                this.buildSpinner();
            }
            this.renderer.setProperty(this.spinnerElement.textElement, 'innerHTML', text);
            const id = text.replace(/[^a-zA-Z0-9-_ ]/gi, '').trim().replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase() + '-message';
            this.renderer.setAttribute(this.spinnerElement.textElement, 'data-automation-id', id);
        }
    }

    private backdropElement;
    private spinnerElement;

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    buildSpinner(): void {
        this.backdropElement = this.renderer.createElement('div');
        this.renderer.setAttribute(this.backdropElement, 'class', 'spinnerBackdrop');
        const customBorderRadius = window.getComputedStyle(this.el.nativeElement, null).getPropertyValue('border-radius');
        if (customBorderRadius) {
            this.renderer.setStyle(this.backdropElement, 'border-radius', customBorderRadius);
        }
        this.renderer.appendChild(this.el.nativeElement, this.backdropElement);

        this.spinnerElement = this.renderer.createElement('div');
        this.renderer.setAttribute(this.spinnerElement, 'class', 'spinnerElement');

        const image = this.renderer.createElement('i');
        this.renderer.setAttribute(image, 'class', 'spinnerImage fa fa-spinner fa-spin');
        this.renderer.appendChild(this.spinnerElement, image);

        this.spinnerElement.textElement = this.renderer.createElement('div');
        this.renderer.setAttribute(this.spinnerElement.textElement, 'class', 'spinnerText');
        this.renderer.appendChild(this.spinnerElement, this.spinnerElement.textElement);

        this.renderer.appendChild(this.el.nativeElement, this.spinnerElement);

        if (this.el.nativeElement.className !== 'login-body') {
            const position = window.getComputedStyle(this.el.nativeElement).getPropertyValue('position');
            if (position === 'static' || position === '' || typeof position === 'undefined') {
                this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
            }
        }
    }
}
